export  default {
    getAddSiteResults(state) {
        return state.newSite;
    },
    getDecommissionSiteResults(state) {
        return state.decommissionSite;
    },
    getSwitchDeviceResults(state) {
        return state.switchDevice;
    },
    getBulkImportResults(state) {
        return state.bulkImportResults;
    }
};